import React from 'react';
import { useSelector } from 'react-redux';
import { useUpdateCompany } from '../../hooks/useCompanies';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    Select,
    Typography,
} from "@mui/material";

function CompanyStatusChange({item, style, handleClose1 }){
    /// allow for super admin to change business status
    const updateCompany = useUpdateCompany();
    const userId = useSelector((state) => state.UserReducer.isAuthenticated?.id);
    const [status, setStatus] = React.useState(null);
    const handleChange = (event) => {
        setStatus(Number(event.target.value));
    };

    async function updateCompanyStatus(item){
        const companyStatus = status ?? item?.companyStatus;
        var companyToSend = {
            Id: item.id,
            Name: item.name,
            Street: item.street,
            CompanyStatus: companyStatus,
            Email: item.email,
            AccountingEmail: item.accountingEmail,
            PhoneNumber: item.phoneNumber,
            City: item.city,
            State: item.state,
            Zip: item.zip,
            Country: item.country,
            ProcessExternal: item.processExternal,
            companyRate: item.companyRate
        }
        await updateCompany.mutateAsync({ company: companyToSend, userId });
        handleClose1();
    };

    return(
        <Box sx={style}>
            <Typography>Set Status</Typography>
            <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <FormControl sx={{ m: 2, minWidth: 120 }}>
                    <InputLabel htmlFor="demo-dialog-native">Status</InputLabel>
                    <Select
                        native
                        value={status ?? item?.companyStatus ?? ''}
                        onChange={handleChange}
                    >
                        <option aria-label="None" value="" />
                        <option value={0}>Pending</option>
                        <option value={1}>Approved w/ Invoice</option>
                        <option value={2}>Approved w/ Credit Card</option>
                        <option value={3}>Denied</option>
                    </Select>
                    <Button onClick={()=>updateCompanyStatus(item)}>Update Status</Button>
                </FormControl>
            </Box>
        </Box>
    )
};

export default CompanyStatusChange;